import { render } from "./ArtistRating.vue?vue&type=template&id=d0bc1376&scoped=true&ts=true"
import script from "./ArtistRating.vue?vue&type=script&lang=ts"
export * from "./ArtistRating.vue?vue&type=script&lang=ts"

import "./ArtistRating.vue?vue&type=style&index=0&id=d0bc1376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bc1376"]])

export default __exports__